import { useLoaders, useTableFilter, useTableServerSideFiltering } from '@/shared';
import { useFetchSaldos } from '@/shared/actions/erp';
import { GeneralTable } from '@/shared/components/ui';
import { Contrato, Saldo } from '@/shared/interfaces';
import { Grid } from '@mui/material';
import { useColumnsSaldo } from '../../../hooks';

export type ClienteFibraSaldoTabProps = {
  contract: Contrato;
};

const ClienteFibraSaldoTab: React.FC<ClienteFibraSaldoTabProps> = ({
  contract,
}) => {
  ///* table ---------------------------
  // server side filters - colums table
  const {  columnFilters, setColumnFilters } =
    useTableServerSideFiltering();

  const { pagination, setPagination } = useTableFilter();
  const { pageIndex, pageSize } = pagination;

  const { data: saldoPagingRes, isLoading: isLoadingSaldo,
    isRefetching: isRefetchingSaldo

  } = useFetchSaldos({
    cliente: contract.cliente!,
    page_size: pageSize,
    page: pageIndex + 1,

  })
  ///* fetch data -------------------------

  useLoaders(isLoadingSaldo || isRefetchingSaldo);

  ///* columns -------------------------
  const { columnsSaldo } = useColumnsSaldo({
    contract,
  });

  return (
    <Grid item container xs={12}>
      {/* ================= table ================= */}
      <Grid item xs={12}>
        <GeneralTable<Saldo>
          columns={columnsSaldo}
          data={saldoPagingRes?.data?.data || []}
          //
          isLoading={isLoadingSaldo}
          isRefetching={isRefetchingSaldo}
          // // filters - llega al back
          enableManualFiltering={true}
          columnFilters={columnFilters}
          onColumnFiltersChange={setColumnFilters}
          // // search
          enableGlobalFilter={false}
          // // pagination
          pagination={pagination}
          onPaging={setPagination}
          rowCount={saldoPagingRes?.data?.count}
          // // actions
          // custom actions - custom colum
          enableColumnActions={false}
          enableEditing={false}
          canDelete={false}
        />
      </Grid>
    </Grid>
  );
};

export default ClienteFibraSaldoTab;
